import React from 'react';
import { sectionPath } from '../../../lib/config';
import ArticleSelector from '../../articles/ArticleSelector';
import { Controller } from 'react-hook-form';

export const NewsBlock = props => {
	const { control } = props;
	return (
		<Controller
			name="config.article"
			control={control}
			render={({ field: { onChange, value } }) => (
				<ArticleSelector
					limit={1}
					section={sectionPath.news}
					floatingLabelFixed
					placeholder="Начните ввод"
					hint="Выберите статью"
					viewer={props.viewer}
					value={value ? value : []}
					onChange={value => {
						onChange(value.length > 1 ? [value.at(-1)] : value);
					}}
				/>
			)}
		/>
	);
};



// WEBPACK FOOTER //
// src/components/configurable-blocks/parts/NewsBlock.jsx